import { jsx as _jsx } from "react/jsx-runtime";
import { createGlobalStyle, css } from 'styled-components';
import { responsive, zIndices } from '@design-system/theme';
import { getBoxShadow } from '../utils/getBoxShadow';
export const GlobalFlatpickrStyles = ({ IconComponent, iconPaddingValue, isClearable, }) => (_jsx(GlobalStyle, { "$hasLeftIcon": Boolean(IconComponent), "$hasRightIcon": isClearable, "$iconPaddingValue": iconPaddingValue }));
const GlobalStyle = createGlobalStyle `
  ${({ theme }) => css `
    .form-control {
      background: transparent !important;
      border-radius: 0 !important;
      border: 0 !important;
      color: ${theme.input.color} !important;
      // To avoid zoom on iOS mobile devices, inputs must have font-size set to 16px on s & m
      font-size: ${theme.fontSizes[3]} !important;
      ${responsive('l') `
        font-size: ${theme.fontSizes[2]} !important;
      `}
      padding: ${theme.space[3] - 1}px !important;
      width: 100%;

      &:focus {
        outline: none !important;
      }

      ${({ $hasLeftIcon, $iconPaddingValue }) => $hasLeftIcon &&
    css `
          padding-left: ${$iconPaddingValue}px !important;
        `}

      ${({ $hasRightIcon, $iconPaddingValue }) => $hasRightIcon &&
    css `
          padding-right: ${$iconPaddingValue}px !important;
        `}
    }

    .flatpickr-input.flatpickr-mobile {
      background: transparent !important;
      border-radius: 0 !important;
      border: 0 !important;
      color: ${theme.colors.asphalt};
      font-size: inherit;
      font: inherit;
      padding: 10px;
      width: 100%;

      &:focus {
        box-shadow: ${getBoxShadow({ $isFocus: true, theme })};
      }

      // To avoid zoom on iOS mobile devices, inputs must have font-size set to 16px on s & m
      font-size: ${theme.fontSizes[3]} !important;
      ${responsive('l') `
        font-size: ${theme.fontSizes[2]} !important;
      `}

      ${({ $hasLeftIcon, $iconPaddingValue }) => $hasLeftIcon &&
    css `
          padding-left: ${$iconPaddingValue}px !important;
        `}

      ${({ $hasRightIcon, $iconPaddingValue }) => $hasRightIcon &&
    css `
          padding-right: ${$iconPaddingValue}px !important;
        `}
    }

    .flatpickr-calendar.open.open {
      z-index: ${zIndices.popover};
    }

    .flatpickr-time .numInput {
      border: 0 !important;
    }

    .flatpickr-current-month .numInputWrapper {
      top: 0px !important;
    }

    .flatpickr-day {
      border: none !important;
    }

    .flatpickr-day.selected {
      background-color: ${theme.colors.primary} !important;
      color: white !important;
    }

    .flatpickr-monthDropdown-months {
      box-shadow: none;
    }

    .flatpickr-input.flatpickr-mobile {
      min-height: 40px;
    }
  `}`;
//# sourceMappingURL=GlobalFlatpickrStyles.js.map